var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text-h6 text-center font-weight-bold primary--text"},[_vm._v(" "+_vm._s(_setup.props.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }